import type { Plan } from '../types'

const INTERVAL_LABEL: Record<string, string> = {
  month: 'mês',
  year: 'ano',
}

export function formatPlanLabel(p: Pick<Plan, 'name'|'amount_cents'|'currency'|'interval'>): string {
  const price = Math.max(0, Number(p.amount_cents || 0)) / 100
  const currency = String(p.currency || 'BRL').toUpperCase()
  const interval = INTERVAL_LABEL[p.interval] || p.interval
  const priceStr = price.toLocaleString('pt-BR', { style: 'currency', currency })
  return `${p.name} • ${priceStr} / ${interval}`
}

